import { DistanceUnits } from '../enums';
import { AppDefaults } from '../types/app';

export const appDefaults = Object.freeze({
  companyAddress: '',
  companyName: '',
  companyPhone: '',
  markup: 0,
  minTime: 0,
  searchRadius: {
    number: 15,
    metric: DistanceUnits.Miles
  }
} as AppDefaults);
